<template>
	
	<div class="default-bg">
		<normalBar title="物流详情"></normalBar>
		<div  v-if="expressList">
			<div class="cancel-info-sec">
				<div class="info-item active" v-for="item in expressList" >
					<span class="icon-circel"></span>
					<div class="text">
						<div>
							<p class="text-grey">{{item.createdTime}}</p>
							<p>{{item.optionHistory}}</p>
						</div>
					</div>
				</div>
			</div>
			<span class="line"></span>
		</div>
		<div class="text-center" v-else>暂无数据</div>
	</div>
</template>


<script>
	import Vue from 'vue';
	import { Picker } from '@/js/mint-ui';
	import { Popup } from '@/js/mint-ui';
	Vue.component(Popup.name, Popup);
	Vue.component(Picker.name, Picker);
	import normalBar from '@/components/common/navbar/normalBar'
	import api from '@/api/api'

	import { mapState } from 'vuex'
	export default {
		computed:{
			...mapState({
				expressList: state => state.expressList.expressList
			})
		},
		components: {
			normalBar
		},
		mounted(){
			let self = this;
			let orderId = this.$route.params.orderId;
			this.$store.dispatch('getExpressList',orderId)
		}
	}

</script>


<style lang="scss">
	@import '../../assets/css/mixin';
	.cancel-info-sec {
		position: relative;
		

		.info-item {
			margin-top: pxToRem(20px);
			display: flex;
			justify-content: center;
			align-items: center;
			
			.text {
				padding-left: pxToRem(25px);
				margin-left: pxToRem(40px);
				width: pxToRem(594px);
				height: pxToRem(140px);
				color: #BDBDBD;
				background-color: #fff;
				display: inline-flex;
				align-items: center;
				.text-grey {
					margin-top: pxToRem(10px);
				}
			}

			.icon-circel {
				display: inline-block;
				width: 10px;
				height: 10px;
				border: 1px solid #ccc;
				border-radius: 50%;
				position: relative;
				background: #eee;
				z-index: 999;
			}

			&.active {
				.text {
					color: #191919;
				}
				.icon-circel {
					border-color: #D8331D;
				}
			}
		}

	}

	.line  {
		width: 1px;
		background-color: #ccc;
		position: absolute;
		left: pxToRem(58px);
		top: 50px;
		bottom: 0;
		z-index: 0;
	}
	
	.refund-tips {
		position: absolute;
		bottom: pxToRem(50px);
		width: 100%;
		text-align: center;

	}

	.text-center {
		margin: 50px 0;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// expressList.vue?58f9a992